import RestaurantBanner from "./RestaurantBanner";
import { lazy, Suspense } from "react";

const RestaurantIndustry = lazy(() => import("./RestaurantIndustry"));
const RestaurantMagic = lazy(() => import("./RestaurantMagic"));
const RestaurantMargin = lazy(() => import("./RestaurantMargin"));
const RestaurantMobile = lazy(() => import("./RestaurantMobile"));
const RestaurantExcellence = lazy(() => import("./RestaurantExcellence"));

const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));

const faqData = [
  {
    id: "0",
    question: "01. What features should a restaurant mobile app include?",
    answer:
      "A restaurant app should include table booking, online food ordering, menu display, delivery management, inventory tracking, and analytics. Advanced features like kitchen management and waiter management further enhance efficiency.",
  },
  {
    id: "1",
    question: "02. Can the app integrate with third-party services?",
    answer:
      "Our apps support third-party integrations, including payment gateways, review platforms, and social media sharing, to ensure a seamless user experience.",
  },
  {
    id: "2",
    question: "03. How does the app help with inventory management?",
    answer:
      "Our inventory management system automatically tracks stock levels and updates item availability in real-time, ensuring smooth operations.",
  },
  {
    id: "3",
    question: "04. Can the app handle online food delivery and takeaways?",
    answer:
      "Absolutely! The app has an online food ordering management system allowing users to choose delivery, takeaway, or dine-in options.",
  },
  {
    id: "4",
    question: "05. What are the benefits of kitchen management in the app?",
    answer:
      "Kitchen management ensures that orders are digitally sent to the kitchen based on table numbers, improving accuracy and reducing preparation time.",
  },
  {
    id: "5",
    question: "06. Does the app support payroll and accounting?",
    answer:
      "The app includes payroll and accounting software to streamline employee payments and manage business finances effortlessly.",
  },
  {
    id: "6",
    question:
      "07. Could I customize the app to meet my restaurant’s specific needs?",
    answer:
      "Definitely! We provide custom app development tailored to your restaurant's requirements, including unique features and branding.",
  },
  {
    id: "7",
    question: "08. How does the app improve customer experience?",
    answer:
      "The app enhances customer experience through features like easy menu browsing, table reservations, real-time waitlist tracking, and fast online food ordering, making dining more convenient.",
  },
];

export default function Restaurant() {
  return (
    <>
      <RestaurantBanner />

      <Suspense fallback={null}>
        <RestaurantIndustry />
        <RestaurantMagic />
        <RestaurantMargin />
        <RestaurantMobile />
        <RestaurantExcellence />
        <ShuttleAppreciation />
        <ShuttleItNeed />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  )
}
